import '../SectionMainOffers/section-main-offers.css';
import Container from '../../@common.blocks/Container';
import Title from '../../@common.blocks/Title/index';
import Button from '../../@common.blocks/Button/index';
import { HashLink } from 'react-router-hash-link';

const SectionMainOffers = () => {
  return (
    <div className="section-main-offers">
      <div className="section-main-offers__wrapper band">
        <Container>
          <div className="section-main-offers__wrapper-content">
            <Title level="2" color="white">
              Отправить нам сообщение
            </Title>
            <p>
              Если у Вас есть какие-то вопросы или предложения по
              сотрудничеству-заполните форму ниже.
            </p>
            <HashLink to="/fill_the_form">
              <Button color="orange">Заполните форму</Button>
            </HashLink>
          </div>
        </Container>
      </div>
    </div>
  );
};
export default SectionMainOffers;
